import { useEffect, useState } from "react";
import { Alert, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { resetAlertMessage } from "../actions/cartActions";
import { RootState } from "../reducers";

const AlertOutStock = () => {
  const alertMessage = useSelector(
    (state: RootState) => state.cart.alertMessage
  );
  const showAlert = alertMessage ? true : false;
  const dispatch: any = useDispatch()

  const [show, setShow] = useState(showAlert);
  const handleClose = () => {
    setShow(false)
    dispatch(resetAlertMessage())
  };
  useEffect(() => {
    setShow(showAlert);
  }, [showAlert]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Title>
        <Alert
          variant="info"
          className="mb-0 text-center"
          onClose={handleClose}
          dismissible
        >
          <p>{alertMessage}</p>
        </Alert>
      </Modal.Title>
    </Modal>
  );
};

export default AlertOutStock;
